import { filter, map } from "lodash";
import { FC } from "react";
import styles from "./styles.scss";
import { NewsListItem as NewsListItemComponent } from "@/pages/home/components/news-list/news-list-item";
import { NewsListProps } from "@/pages/home/components/news-list/types";

export const NewsList: FC<NewsListProps> = ({ data }) => {
  const activeNews = filter(data, item => item.IsActive);

  return (
    <div className={styles.newsScrollWrapper}>
      <ul className={styles.newsWrapper}>
        {map(activeNews, (item, index) => (
          <NewsListItemComponent key={`news-list-${index}`} {...item} />
        ))}
      </ul>
    </div>
  );
};
